import React from 'react';
import SearchContactButtonBar from '../SearchContactButtonBar/SearchContactButtonBar';
import { Button, Stack, Typography } from '@mui/material';
import { IS_UXBEAUTY } from 'components/constants/Constants';
import { SearchDocument, SearchRequest } from 'types/Search';
import { Link } from 'react-router-dom';
import Close from '@mui/icons-material/Close';
interface Props {
  compareItem: SearchDocument;
  searchRequest?: SearchRequest;
  onRemoveItemClick: (itemId: string) => void;
}
export const SearchCompareHeader: React.FC<Props> = props => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Stack
        sx={{
          alignItems: 'start',
          justifyContent: 'space-between',
          gap: 2
        }}
      >
        {
          <SearchContactButtonBar
            product={props.compareItem}
            showAddToProject={!IS_UXBEAUTY}
            logEventsData={props.searchRequest}
          />
        }
        <Typography
          sx={{
            typography: {
              xs: 'body1',
              //TODO: when we have proper heading on covalo lets rework this
              sm: IS_UXBEAUTY ? 'h3' : 'h4'
            }
          }}
        >
          {props.compareItem.name}
        </Typography>

        {IS_UXBEAUTY && (
          <Typography>
            {/* //TODO This is the short description for uxbeauty */}
            {props.compareItem.marketing?.description}
          </Typography>
        )}
        <Button
          size="small"
          variant="outlined"
          component={Link}
          to={`/ingredients/permalink/${
            //TODO: switch here between covalo link and uxbeauty link if we need this button on covalo
            props.compareItem.id ? props.compareItem.id : ''
          }`}
        >
          Open ingredient page
        </Button>
      </Stack>
      <Close
        fontSize="small"
        onClick={() => {
          props.compareItem.id && props.onRemoveItemClick(props.compareItem.id);
        }}
      />
    </div>
  );
};
